import { render, staticRenderFns } from "./LegalPageTemplate.vue?vue&type=template&id=b2877f9c&scoped=true"
import script from "./LegalPageTemplate.vue?vue&type=script&lang=js"
export * from "./LegalPageTemplate.vue?vue&type=script&lang=js"
import style0 from "./LegalPageTemplate.vue?vue&type=style&index=0&id=b2877f9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2877f9c",
  null
  
)

export default component.exports